module.exports = __webpack_public_path__ + "static/media/orange.5d691470.png";